import { createSlice } from '@reduxjs/toolkit';

const getUserFromLocalStorage = () => {
    try {
        const user = localStorage.getItem('user');
        return user ? JSON.parse(user) : null;
    } catch (error) {
        console.error("Error parsing user from localStorage:", error);
        return null;
    }
};

const getTokenFromLocalStorage = () => {
    return localStorage.getItem('token') || null;
};

const initialState = {
    user: getUserFromLocalStorage(), // Initialize from localStorage
    token: getTokenFromLocalStorage(), // Initialize from localStorage
    isAuthenticated: !!getTokenFromLocalStorage(), // Derive isAuthenticated from token
    isLoading: false,
    error: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (state, action) => {
            console.log("setCredentials->state:", state);
            console.log("setCredentials->action:", action);
            const { user, token } = action.payload;
            if (user) localStorage.setItem('user', JSON.stringify(user));
            if (token) localStorage.setItem('token', token);
            console.log("setCredentials:user->", user);
            state.user = user;
            state.token = token;
            state.isAuthenticated = true;
        },
        logOut: (state) => {
            state.user = null;
            state.token = null;
            state.isAuthenticated = false;
            localStorage.clear();
            sessionStorage.clear();
        },
    },
});

export const { setCredentials, logOut } = authSlice.actions;
export default authSlice.reducer;
export const getCurrentUser = (state) => state.auth.user;